import {
  cardTitle,
  blackColor,
  hexToRgb
} from "../../material-dashboard-pro-react.js";
import customSelectStyle from "../customSelectStyle.js";
import customCheckboxRadioSwitch from "../customCheckboxRadioSwitch.js";

const extendedFormsStyle = {
  ...customCheckboxRadioSwitch,
  ...customSelectStyle,
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "10px",
    marginBottom: "0px"
  },
  label: {
    cursor: "pointer",
    paddingLeft: "0",
    color: "rgba(" + hexToRgb(blackColor) + ", 0.80)",
    fontSize: "12px",
    lineHeight: "1.428571429",
    fontWeight: "400",
    display: "inline-flex",
    textAlign: "left"
  },
  mrAuto: {
    marginRight: "auto"
  },
  mlAuto: {
    marginLeft: "auto"
  }
};

export default extendedFormsStyle;
